/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.179.0-v202608122344-CD
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqContextApiClass {
 
   constructor() {}

  /**
   * @summary Set condition assignments for a reason code hierarchy in a workbook. This endpoint is experimental and may change in future releases.
   * @param {string} categoryId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public assignReasonCodeHierarchy(
    body: models.ReasonCodeAssignmentInputV1,
    {
      categoryId
    } : {
      categoryId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (categoryId === null || categoryId === undefined) {
      throw new Error("'categoryId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/reason-codes/${encodeURIComponent(String(categoryId))}/assignments`
      .replace('{categoryId}', encodeURIComponent(String(categoryId)));



    return axiosInstance.request({
      method: 'put',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<{}>;
  }

  /**
   * @summary Archive multiple context labels
   * @param {string} itemId - ID of the item that the labels are associated with
  */
  public batchArchiveContextLabels(
    body: models.BatchArchiveContextLabelsInputV1,
    {
      itemId
    } : {
      itemId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (itemId === null || itemId === undefined) {
      throw new Error("'itemId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/${encodeURIComponent(String(itemId))}/labels/batch/archive`
      .replace('{itemId}', encodeURIComponent(String(itemId)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<{}>;
  }

  /**
   * @summary Create or update multiple labels
   * @param {string} itemId - ID of the item that the labels are associated with
  */
  public batchCreateContextLabels(
    body: Array<models.ContextLabelWithIdInputV1>,
    {
      itemId
    } : {
      itemId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (itemId === null || itemId === undefined) {
      throw new Error("'itemId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/${encodeURIComponent(String(itemId))}/labels/batch`
      .replace('{itemId}', encodeURIComponent(String(itemId)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<Array<models.ContextLabelOutputV1>>;
  }

  /**
   * @summary Create or update context labels, comments, and numerics across many items. This endpoint is experimental and may change in future releases.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public bulkApplyContext(
    body: models.BulkContextInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/bulk`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.BulkContextOutputV1>;
  }

  /**
   * @summary Archive context labels, comments, and numerics across many items. This endpoint is experimental and may change in future releases.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public bulkArchiveContext(
    body: models.BulkContextArchiveInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/bulk/archive`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.BulkContextArchiveOutputV1>;
  }

  /**
   * @summary Create a new comment category
  */
  public createCommentCategory(
    body: models.CommentCategoryInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/comments/categories`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.CommentCategoryOutputV1>;
  }

  /**
   * @summary Create a new comment associated with an Item
   * @param {string} itemId - ID of the item that the comment is associated with
  */
  public createContextComment(
    body: models.ContextCommentInputV1,
    {
      itemId
    } : {
      itemId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (itemId === null || itemId === undefined) {
      throw new Error("'itemId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/${encodeURIComponent(String(itemId))}/comments`
      .replace('{itemId}', encodeURIComponent(String(itemId)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ContextCommentOutputV1>;
  }

  /**
   * @summary Create a new label associated with an item
   * @param {string} itemId - ID of the item that the label is associated with
  */
  public createContextLabel(
    body: models.ContextLabelInputV1,
    {
      itemId
    } : {
      itemId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (itemId === null || itemId === undefined) {
      throw new Error("'itemId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/${encodeURIComponent(String(itemId))}/labels`
      .replace('{itemId}', encodeURIComponent(String(itemId)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ContextLabelOutputV1>;
  }

  /**
   * @summary Create a new numeric context associated with an item
   * @param {string} itemId - ID of the item that the numeric context is associated with
  */
  public createContextNumeric(
    body: models.ContextNumericInputV1,
    {
      itemId
    } : {
      itemId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (itemId === null || itemId === undefined) {
      throw new Error("'itemId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/${encodeURIComponent(String(itemId))}/numeric`
      .replace('{itemId}', encodeURIComponent(String(itemId)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ContextNumericOutputV1>;
  }

  /**
   * @summary Create new opaque context associated with an item
   * @param {string} itemId - ID of the item that the opaque context is associated with
  */
  public createContextOpaque(
    body: models.ContextOpaqueInputV1,
    {
      itemId
    } : {
      itemId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (itemId === null || itemId === undefined) {
      throw new Error("'itemId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/${encodeURIComponent(String(itemId))}/opaque`
      .replace('{itemId}', encodeURIComponent(String(itemId)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ContextOpaqueOutputV1>;
  }

  /**
   * @summary Create a new label
  */
  public createLabel(
    body: models.LabelInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/labels`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.LabelOutputV1>;
  }

  /**
   * @summary Create a new label category
  */
  public createLabelCategory(
    body: models.LabelCategoryInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/labels/categories`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.LabelCategoryOutputV1>;
  }

  /**
   * @summary Create a new numeric description
  */
  public createNumericDescription(
    body: models.NumericDescriptionInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/numeric`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.NumericDescriptionOutputV1>;
  }

  /**
   * @summary Create a new reason code hierarchy. This endpoint is experimental and may change in future releases.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public createReasonCodeHierarchy(
    body: models.ReasonCodeHierarchyInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/reason-codes`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ReasonCodeHierarchyOutputV1>;
  }

  /**
   * @summary Delete a comment category
   * @param {string} id
  */
  public deleteCommentCategory(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/comments/categories/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'delete',
      url,
      ...restOverrides
    }) as AxiosPromise<{}>;
  }

  /**
   * @summary Delete or archive a comment
   * @param {string} itemId - ID of the item that the comment is associated with
   * @param {string} commentId - The comment ID to be deleted
   * @param {boolean} [_delete=false] - Permanently and irretrievably delete the comment
  */
  public deleteContextComment(
    {
      itemId,
      commentId,
      _delete
    } : {
      itemId: string,
      commentId: string,
      _delete?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (itemId === null || itemId === undefined) {
      throw new Error("'itemId' parameter required");
    }

    if (commentId === null || commentId === undefined) {
      throw new Error("'commentId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/${encodeURIComponent(String(itemId))}/comments/${encodeURIComponent(String(commentId))}`
      .replace('{itemId}', encodeURIComponent(String(itemId)))
      .replace('{commentId}', encodeURIComponent(String(commentId)));

    const queryParams = {
      ['delete']: _delete
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'delete',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Archive a label
   * @param {string} itemId - ID of the item that the label is associated with
   * @param {string} labelId - The context label ID to be archived
   * @param {string} [tableId] - If provided, the ID of the Table Definition that will be used for permissions checking. The user needs read permissions on the provided table definition and theitem has to be in the table in order to create, update, or delete context. If not provided, the user must have read permissions on the item id the context is being applied to.
   * @param {boolean} [archiveChildren] - If true, child labels and all of their descendants will also be archived.
  */
  public deleteContextLabel(
    {
      itemId,
      labelId,
      tableId,
      archiveChildren
    } : {
      itemId: string,
      labelId: string,
      tableId?: string,
      archiveChildren?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (itemId === null || itemId === undefined) {
      throw new Error("'itemId' parameter required");
    }

    if (labelId === null || labelId === undefined) {
      throw new Error("'labelId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/${encodeURIComponent(String(itemId))}/labels/${encodeURIComponent(String(labelId))}`
      .replace('{itemId}', encodeURIComponent(String(itemId)))
      .replace('{labelId}', encodeURIComponent(String(labelId)));

    const queryParams = {
      ['tableId']: tableId,      ['archiveChildren']: archiveChildren
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'delete',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ArchiveOutputV1>;
  }

  /**
   * @summary Delete or archive a numeric context
   * @param {string} itemId - ID of the item that the numeric context is associated with
   * @param {string} numericContextId - The context numeric ID to be deleted
   * @param {string} [tableId] - If provided, the ID of the Table Definition that will be used for permissions checking. The user needs read permissions on the provided table definition and theitem has to be in the table in order to create, update, or delete context. If not provided, the user must have read permissions on the item id the context is being applied to.
   * @param {boolean} [_delete] - Permanently and irretrievably delete the numeric context
  */
  public deleteContextNumeric(
    {
      itemId,
      numericContextId,
      tableId,
      _delete
    } : {
      itemId: string,
      numericContextId: string,
      tableId?: string,
      _delete?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (itemId === null || itemId === undefined) {
      throw new Error("'itemId' parameter required");
    }

    if (numericContextId === null || numericContextId === undefined) {
      throw new Error("'numericContextId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/${encodeURIComponent(String(itemId))}/numeric/${encodeURIComponent(String(numericContextId))}`
      .replace('{itemId}', encodeURIComponent(String(itemId)))
      .replace('{numericContextId}', encodeURIComponent(String(numericContextId)));

    const queryParams = {
      ['tableId']: tableId,      ['delete']: _delete
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'delete',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Delete or archive opaque context
   * @param {string} itemId - ID of the item that the opaque context is associated with
   * @param {string} opaqueId - The opaque ID to be deleted
   * @param {boolean} [_delete=false] - Permanently and irretrievably delete the opaque context
   * @param {string} [tableId] - If provided, the ID of the Table Definition that will be used for permissions checking. The user needs read permissions on the provided table definition and theitem has to be in the table in order to create, update, or delete context. If not provided, the user must have read permissions on the item id the context is being applied to.
  */
  public deleteContextOpaque(
    {
      itemId,
      opaqueId,
      _delete,
      tableId
    } : {
      itemId: string,
      opaqueId: string,
      _delete?: boolean,
      tableId?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (itemId === null || itemId === undefined) {
      throw new Error("'itemId' parameter required");
    }

    if (opaqueId === null || opaqueId === undefined) {
      throw new Error("'opaqueId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/${encodeURIComponent(String(itemId))}/opaque/${encodeURIComponent(String(opaqueId))}`
      .replace('{itemId}', encodeURIComponent(String(itemId)))
      .replace('{opaqueId}', encodeURIComponent(String(opaqueId)));

    const queryParams = {
      ['delete']: _delete,      ['tableId']: tableId
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'delete',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Delete or archive a specific label.
   * @param {string} labelId - ID of the label
   * @param {boolean} [_delete] - Permanently and irretrievably delete the category
  */
  public deleteLabel(
    {
      labelId,
      _delete
    } : {
      labelId: string,
      _delete?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (labelId === null || labelId === undefined) {
      throw new Error("'labelId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/labels/${encodeURIComponent(String(labelId))}`
      .replace('{labelId}', encodeURIComponent(String(labelId)));

    const queryParams = {
      ['delete']: _delete
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'delete',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ArchiveOutputV1>;
  }

  /**
   * @summary Delete or archive a specific label category.
   * @param {string} categoryId - ID of the category
   * @param {boolean} [_delete=false] - Permanently and irretrievably delete the category
  */
  public deleteLabelCategory(
    {
      categoryId,
      _delete
    } : {
      categoryId: string,
      _delete?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (categoryId === null || categoryId === undefined) {
      throw new Error("'categoryId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/labels/categories/${encodeURIComponent(String(categoryId))}`
      .replace('{categoryId}', encodeURIComponent(String(categoryId)));

    const queryParams = {
      ['delete']: _delete
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'delete',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ArchiveOutputV1>;
  }

  /**
   * @summary Delete a numeric description
   * @param {string} id
  */
  public deleteNumericDescription(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/numeric/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'delete',
      url,
      ...restOverrides
    }) as AxiosPromise<{}>;
  }

  /**
   * @summary Delete a reason code hierarchy. This endpoint is experimental and may change in future releases.
   * @param {string} categoryId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public deleteReasonCodeHierarchy(
    {
      categoryId
    } : {
      categoryId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (categoryId === null || categoryId === undefined) {
      throw new Error("'categoryId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/reason-codes/${encodeURIComponent(String(categoryId))}`
      .replace('{categoryId}', encodeURIComponent(String(categoryId)));



    return axiosInstance.request({
      method: 'delete',
      url,
      ...restOverrides
    }) as AxiosPromise<{}>;
  }

  /**
   * @summary Get all label categories
   * @param {string} [parentId] - If set to the ID of a parent category then the child categories will be returned; if set to the empty GUID (00000000-0000-0000-0000-000000000000) only top level categories will be returned; if not specified all categories will be returned
   * @param {boolean} [includeArchived] - If set to true, archived categories will be included in the results. Default is false.
  */
  public findLabelCategories(
    {
      parentId,
      includeArchived
    } : {
      parentId?: string,
      includeArchived?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/labels/categories`;

    const queryParams = {
      ['parentId']: parentId,      ['includeArchived']: includeArchived
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.LabelCategoryOutputListV1>;
  }

  /**
   * @summary Get all labels for a given category
   * @param {string} categoryId - ID of the category of labels to return
   * @param {string} [query] - Search for labels that contain this string in a case-insensitive manner. This is especially useful for autocomplete categories. Note that if this is specified only the first 20 results will be returned, ordered by name
   * @param {string} [parentId] - If set to the ID of a parent label then the child labels will be returned; if set to the empty GUID (00000000-0000-0000-0000-000000000000) only top level labels will be returned; if not specified all labels will be returned
   * @param {boolean} [includeArchived] - If set to true, archived labels will be included in the results. Default is false.
  */
  public findLabels(
    {
      categoryId,
      query,
      parentId,
      includeArchived
    } : {
      categoryId: string,
      query?: string,
      parentId?: string,
      includeArchived?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (categoryId === null || categoryId === undefined) {
      throw new Error("'categoryId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/labels/${encodeURIComponent(String(categoryId))}`
      .replace('{categoryId}', encodeURIComponent(String(categoryId)));

    const queryParams = {
      ['query']: query,      ['parentId']: parentId,      ['includeArchived']: includeArchived
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.LabelOutputListV1>;
  }

  /**
   * @summary Get all comment categories
  */
  public getAllCommentCategories(
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/comments/categories`;



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.CommentCategoryOutputListV1>;
  }

  /**
   * @summary Fetch all context types for specified item IDs
  */
  public getAllContext(
    body: models.GetAllContextInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/search/all`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.AllContextOutputV1>;
  }

  /**
   * @summary Get all numeric descriptions
  */
  public getAllNumericDescriptions(
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/numeric/descriptions`;



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.NumericDescriptionOutputListV1>;
  }

  /**
   * @summary Fetch available selector properties for specified condition IDs. This endpoint is experimental and may change in future releases.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getAvailableConditionProperties(
    body: models.GetAvailableConditionPropertiesInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/conditions/availableProperties`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.AvailableConditionPropertiesOutputV1>;
  }

  /**
   * @summary Get comment category by ID
   * @param {string} id
  */
  public getCommentCategory(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/comments/categories/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.CommentCategoryOutputV1>;
  }

  /**
   * @summary Fetch context comments for specified item IDs
  */
  public getContextComments(
    body: models.GetContextInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/search/comments`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ContextCommentListOutputV1>;
  }

  /**
   * @summary Fetch context conditions for specified item IDs
  */
  public getContextConditions(
    body: models.GetContextConditionInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/conditions`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ContextConditionOutputListV1>;
  }

  /**
   * @summary Fetch context labels for specified item IDs
  */
  public getContextLabels(
    body: models.GetContextInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/search/labels`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ContextLabelListOutputV1>;
  }

  /**
   * @summary Fetch numeric context for specified item IDs
  */
  public getContextNumerics(
    body: models.GetContextInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/search/numerics`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ContextNumericListOutputV1>;
  }

  /**
   * @summary Fetch opaque context for specified item IDs
  */
  public getContextOpaque(
    body: models.GetContextInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/search/opaque`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ContextOpaqueListOutputV1>;
  }

  /**
   * @summary Get label hierarchies for given category/label pairs. If no potential match for a given pair exists, nothing is returned for that pair.
  */
  public getLabelHierarchies(
    body: models.LabelHierarchyInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/labels/hierarchies`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.LabelHierarchyOutputListV1>;
  }

  /**
   * @summary Gets all items associated with the given label ID
   * @param {string} labelId - The ID of the label
   * @param {number} [limit] - The pagination limit, the total number of collection items that will be returned in this page of results.
   * @param {number} [offset] - The pagination offset, the index of the first collection item that will be returned in this page of results.
   * @param {boolean} [includeArchivedContext] - If true, items associated via archived context label associations will be included in the results. Defaults to false.
   * @param {boolean} [includeArchivedItems] - If true, archived items will be included in the results. Defaults to false.
  */
  public getLabeledItems(
    {
      labelId,
      limit,
      offset,
      includeArchivedContext,
      includeArchivedItems
    } : {
      labelId: string,
      limit?: number,
      offset?: number,
      includeArchivedContext?: boolean,
      includeArchivedItems?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (labelId === null || labelId === undefined) {
      throw new Error("'labelId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/${encodeURIComponent(String(labelId))}/labels/items`
      .replace('{labelId}', encodeURIComponent(String(labelId)));

    const queryParams = {
      ['limit']: limit,      ['offset']: offset,      ['includeArchivedContext']: includeArchivedContext,      ['includeArchivedItems']: includeArchivedItems
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ItemPreviewListV1>;
  }

  /**
   * @summary Get numeric description. This method is deprecated.
   * @param {string} [id]
   * @deprecated Use /{id} path parameter instead of query parameter
  */
  public getNumericDescription(
    {
      id
    } : {
      id?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/numeric`;

    const queryParams = {
      ['id']: id
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.NumericDescriptionOutputV1>;
  }

  /**
   * @summary Get numeric description by ID
   * @param {string} id
  */
  public getNumericDescriptionWithPathId(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/numeric/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.NumericDescriptionOutputV1>;
  }

  /**
   * @summary Get the full nested tree for a reason code hierarchy. This endpoint is experimental and may change in future releases.
   * @param {string} categoryId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getReasonCodeHierarchyTree(
    {
      categoryId
    } : {
      categoryId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (categoryId === null || categoryId === undefined) {
      throw new Error("'categoryId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/reason-codes/${encodeURIComponent(String(categoryId))}`
      .replace('{categoryId}', encodeURIComponent(String(categoryId)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.ReasonCodeHierarchyTreeOutputV1>;
  }

  /**
   * @summary List reason code hierarchies, optionally scoped to a workbook. This endpoint is experimental and may change in future releases.
   * @param {string} [workbookId] - If provided, also returns condition assignments for this workbook
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public listReasonCodeHierarchies(
    {
      workbookId
    } : {
      workbookId?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/reason-codes`;

    const queryParams = {
      ['workbookId']: workbookId
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ReasonCodeListOutputV1>;
  }

  /**
   * @summary Search for context comments using string fragments and filters. This search is fast but eventually consistent, so recent writes may take time to appear. Results are filtered by read access to the parent items of the comments.
   * @param {string} [query] - String fragment to search for. Text is matched against comment content. If query is not supplied, all comments are returned.
   * @param {string} [sortField] - Field to sort by. Supported values are CreatedAt and UpdatedAt. Leave empty to use the default relevance sorting.
   * @param {string} [sortOrder=DESC] - Sort order for the results. Supported values are ASC and DESC.
   * @param {number} [hitsPerPage=40] - Number of hits to return per page. Defaults to 40.
   * @param {number} [page=1] - One-based page number to retrieve. If zero is specified, no hits are returned and only the hit counts are returned.
   * @param {string} [hitHighlightFormat] - If supplied, enables hit highlighting for matched words in the content. The value must contain a &#x27;%s&#x27; placeholder, for example an HTML tag wrapped around &#x27;%s&#x27;. If not specified, hit highlighting is disabled.
  */
  public searchContextComments(
    {
      query,
      sortField,
      sortOrder,
      hitsPerPage,
      page,
      hitHighlightFormat
    } : {
      query?: string,
      sortField?: SearchContextCommentsSortFieldEnum,
      sortOrder?: SearchContextCommentsSortOrderEnum,
      hitsPerPage?: number,
      page?: number,
      hitHighlightFormat?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/search`;

    const queryParams = {
      ['query']: query,      ['sortField']: sortField,      ['sortOrder']: sortOrder,      ['hitsPerPage']: hitsPerPage,      ['page']: page,      ['hitHighlightFormat']: hitHighlightFormat
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ContextCommentSearchResultsV1>;
  }

  /**
   * @summary Update a comment category
   * @param {string} id
  */
  public updateCommentCategory(
    body: models.CommentCategoryInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/comments/categories/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.CommentCategoryOutputV1>;
  }

  /**
   * @summary Update a comment
   * @param {string} itemId - ID of the item that the comment is associated with
   * @param {string} commentId - ID of the comment to update
  */
  public updateContextComment(
    body: models.ContextCommentInputV1,
    {
      itemId,
      commentId
    } : {
      itemId: string,
      commentId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (itemId === null || itemId === undefined) {
      throw new Error("'itemId' parameter required");
    }

    if (commentId === null || commentId === undefined) {
      throw new Error("'commentId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/${encodeURIComponent(String(itemId))}/comments/${encodeURIComponent(String(commentId))}`
      .replace('{itemId}', encodeURIComponent(String(itemId)))
      .replace('{commentId}', encodeURIComponent(String(commentId)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ContextCommentOutputV1>;
  }

  /**
   * @summary Update a numeric context
   * @param {string} itemId - ID of the item that the numeric context is associated with
   * @param {string} numericContextId - ID of the numeric context to update
  */
  public updateContextNumeric(
    body: models.ContextNumericInputV1,
    {
      itemId,
      numericContextId
    } : {
      itemId: string,
      numericContextId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (itemId === null || itemId === undefined) {
      throw new Error("'itemId' parameter required");
    }

    if (numericContextId === null || numericContextId === undefined) {
      throw new Error("'numericContextId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/${encodeURIComponent(String(itemId))}/numeric/${encodeURIComponent(String(numericContextId))}`
      .replace('{itemId}', encodeURIComponent(String(itemId)))
      .replace('{numericContextId}', encodeURIComponent(String(numericContextId)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ContextNumericOutputV1>;
  }

  /**
   * @summary Update opaque context
   * @param {string} itemId - ID of the item that the opaque context is associated with
   * @param {string} opaqueId - ID of the opaque context to update
  */
  public updateContextOpaque(
    body: models.ContextOpaqueInputV1,
    {
      itemId,
      opaqueId
    } : {
      itemId: string,
      opaqueId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (itemId === null || itemId === undefined) {
      throw new Error("'itemId' parameter required");
    }

    if (opaqueId === null || opaqueId === undefined) {
      throw new Error("'opaqueId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/${encodeURIComponent(String(itemId))}/opaque/${encodeURIComponent(String(opaqueId))}`
      .replace('{itemId}', encodeURIComponent(String(itemId)))
      .replace('{opaqueId}', encodeURIComponent(String(opaqueId)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ContextOpaqueOutputV1>;
  }

  /**
   * @summary Update a label
   * @param {string} labelId
  */
  public updateLabel(
    body: models.LabelInputV1,
    {
      labelId
    } : {
      labelId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (labelId === null || labelId === undefined) {
      throw new Error("'labelId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/labels/${encodeURIComponent(String(labelId))}`
      .replace('{labelId}', encodeURIComponent(String(labelId)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.LabelOutputV1>;
  }

  /**
   * @summary Update a label category
   * @param {string} categoryId
  */
  public updateLabelCategory(
    body: models.LabelCategoryInputV1,
    {
      categoryId
    } : {
      categoryId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (categoryId === null || categoryId === undefined) {
      throw new Error("'categoryId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/labels/categories/${encodeURIComponent(String(categoryId))}`
      .replace('{categoryId}', encodeURIComponent(String(categoryId)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.LabelCategoryOutputV1>;
  }

  /**
   * @summary Update a numeric description
   * @param {string} id
  */
  public updateNumericDescription(
    body: models.NumericDescriptionInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/numeric/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ContextNumericOutputV1>;
  }

  /**
   * @summary Update an existing reason code hierarchy. This endpoint is experimental and may change in future releases.
   * @param {string} categoryId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public updateReasonCodeHierarchy(
    body: models.ReasonCodeHierarchyInputV1,
    {
      categoryId
    } : {
      categoryId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (categoryId === null || categoryId === undefined) {
      throw new Error("'categoryId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/context/reason-codes/${encodeURIComponent(String(categoryId))}`
      .replace('{categoryId}', encodeURIComponent(String(categoryId)));



    return axiosInstance.request({
      method: 'put',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ReasonCodeHierarchyOutputV1>;
  }

}

export const SearchContextCommentsSortFieldEnum = {
    CreatedAt: 'CreatedAt',
    UpdatedAt: 'UpdatedAt'
} as const;

export type SearchContextCommentsSortFieldEnum = typeof SearchContextCommentsSortFieldEnum[keyof typeof SearchContextCommentsSortFieldEnum];
export const SearchContextCommentsSortOrderEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;

export type SearchContextCommentsSortOrderEnum = typeof SearchContextCommentsSortOrderEnum[keyof typeof SearchContextCommentsSortOrderEnum];

export const sqContextApi = new sqContextApiClass();

export type sqContextApiEndpoints = {
  'assignReasonCodeHierarchy': {
    method: 'put';
    path: '/context/reason-codes/${encodeURIComponent(String(categoryId))}/assignments';
    response: {};
  };
  'batchArchiveContextLabels': {
    method: 'post';
    path: '/context/${encodeURIComponent(String(itemId))}/labels/batch/archive';
    response: {};
  };
  'batchCreateContextLabels': {
    method: 'post';
    path: '/context/${encodeURIComponent(String(itemId))}/labels/batch';
    response: Array<models.ContextLabelOutputV1>;
  };
  'bulkApplyContext': {
    method: 'post';
    path: '/context/bulk';
    response: models.BulkContextOutputV1;
  };
  'bulkArchiveContext': {
    method: 'post';
    path: '/context/bulk/archive';
    response: models.BulkContextArchiveOutputV1;
  };
  'createCommentCategory': {
    method: 'post';
    path: '/context/comments/categories';
    response: models.CommentCategoryOutputV1;
  };
  'createContextComment': {
    method: 'post';
    path: '/context/${encodeURIComponent(String(itemId))}/comments';
    response: models.ContextCommentOutputV1;
  };
  'createContextLabel': {
    method: 'post';
    path: '/context/${encodeURIComponent(String(itemId))}/labels';
    response: models.ContextLabelOutputV1;
  };
  'createContextNumeric': {
    method: 'post';
    path: '/context/${encodeURIComponent(String(itemId))}/numeric';
    response: models.ContextNumericOutputV1;
  };
  'createContextOpaque': {
    method: 'post';
    path: '/context/${encodeURIComponent(String(itemId))}/opaque';
    response: models.ContextOpaqueOutputV1;
  };
  'createLabel': {
    method: 'post';
    path: '/context/labels';
    response: models.LabelOutputV1;
  };
  'createLabelCategory': {
    method: 'post';
    path: '/context/labels/categories';
    response: models.LabelCategoryOutputV1;
  };
  'createNumericDescription': {
    method: 'post';
    path: '/context/numeric';
    response: models.NumericDescriptionOutputV1;
  };
  'createReasonCodeHierarchy': {
    method: 'post';
    path: '/context/reason-codes';
    response: models.ReasonCodeHierarchyOutputV1;
  };
  'deleteCommentCategory': {
    method: 'delete';
    path: '/context/comments/categories/${encodeURIComponent(String(id))}';
    response: {};
  };
  'deleteContextComment': {
    method: 'delete';
    path: '/context/${encodeURIComponent(String(itemId))}/comments/${encodeURIComponent(String(commentId))}';
    response: models.StatusMessageBase;
  };
  'deleteContextLabel': {
    method: 'delete';
    path: '/context/${encodeURIComponent(String(itemId))}/labels/${encodeURIComponent(String(labelId))}';
    response: models.ArchiveOutputV1;
  };
  'deleteContextNumeric': {
    method: 'delete';
    path: '/context/${encodeURIComponent(String(itemId))}/numeric/${encodeURIComponent(String(numericContextId))}';
    response: models.StatusMessageBase;
  };
  'deleteContextOpaque': {
    method: 'delete';
    path: '/context/${encodeURIComponent(String(itemId))}/opaque/${encodeURIComponent(String(opaqueId))}';
    response: models.StatusMessageBase;
  };
  'deleteLabel': {
    method: 'delete';
    path: '/context/labels/${encodeURIComponent(String(labelId))}';
    response: models.ArchiveOutputV1;
  };
  'deleteLabelCategory': {
    method: 'delete';
    path: '/context/labels/categories/${encodeURIComponent(String(categoryId))}';
    response: models.ArchiveOutputV1;
  };
  'deleteNumericDescription': {
    method: 'delete';
    path: '/context/numeric/${encodeURIComponent(String(id))}';
    response: {};
  };
  'deleteReasonCodeHierarchy': {
    method: 'delete';
    path: '/context/reason-codes/${encodeURIComponent(String(categoryId))}';
    response: {};
  };
  'findLabelCategories': {
    method: 'get';
    path: '/context/labels/categories';
    response: models.LabelCategoryOutputListV1;
  };
  'findLabels': {
    method: 'get';
    path: '/context/labels/${encodeURIComponent(String(categoryId))}';
    response: models.LabelOutputListV1;
  };
  'getAllCommentCategories': {
    method: 'get';
    path: '/context/comments/categories';
    response: models.CommentCategoryOutputListV1;
  };
  'getAllContext': {
    method: 'post';
    path: '/context/search/all';
    response: models.AllContextOutputV1;
  };
  'getAllNumericDescriptions': {
    method: 'get';
    path: '/context/numeric/descriptions';
    response: models.NumericDescriptionOutputListV1;
  };
  'getAvailableConditionProperties': {
    method: 'post';
    path: '/context/conditions/availableProperties';
    response: models.AvailableConditionPropertiesOutputV1;
  };
  'getCommentCategory': {
    method: 'get';
    path: '/context/comments/categories/${encodeURIComponent(String(id))}';
    response: models.CommentCategoryOutputV1;
  };
  'getContextComments': {
    method: 'post';
    path: '/context/search/comments';
    response: models.ContextCommentListOutputV1;
  };
  'getContextConditions': {
    method: 'post';
    path: '/context/conditions';
    response: models.ContextConditionOutputListV1;
  };
  'getContextLabels': {
    method: 'post';
    path: '/context/search/labels';
    response: models.ContextLabelListOutputV1;
  };
  'getContextNumerics': {
    method: 'post';
    path: '/context/search/numerics';
    response: models.ContextNumericListOutputV1;
  };
  'getContextOpaque': {
    method: 'post';
    path: '/context/search/opaque';
    response: models.ContextOpaqueListOutputV1;
  };
  'getLabelHierarchies': {
    method: 'post';
    path: '/context/labels/hierarchies';
    response: models.LabelHierarchyOutputListV1;
  };
  'getLabeledItems': {
    method: 'get';
    path: '/context/${encodeURIComponent(String(labelId))}/labels/items';
    response: models.ItemPreviewListV1;
  };
  'getNumericDescription': {
    method: 'get';
    path: '/context/numeric';
    response: models.NumericDescriptionOutputV1;
  };
  'getNumericDescriptionWithPathId': {
    method: 'get';
    path: '/context/numeric/${encodeURIComponent(String(id))}';
    response: models.NumericDescriptionOutputV1;
  };
  'getReasonCodeHierarchyTree': {
    method: 'get';
    path: '/context/reason-codes/${encodeURIComponent(String(categoryId))}';
    response: models.ReasonCodeHierarchyTreeOutputV1;
  };
  'listReasonCodeHierarchies': {
    method: 'get';
    path: '/context/reason-codes';
    response: models.ReasonCodeListOutputV1;
  };
  'searchContextComments': {
    method: 'get';
    path: '/context/search';
    response: models.ContextCommentSearchResultsV1;
  };
  'updateCommentCategory': {
    method: 'post';
    path: '/context/comments/categories/${encodeURIComponent(String(id))}';
    response: models.CommentCategoryOutputV1;
  };
  'updateContextComment': {
    method: 'post';
    path: '/context/${encodeURIComponent(String(itemId))}/comments/${encodeURIComponent(String(commentId))}';
    response: models.ContextCommentOutputV1;
  };
  'updateContextNumeric': {
    method: 'post';
    path: '/context/${encodeURIComponent(String(itemId))}/numeric/${encodeURIComponent(String(numericContextId))}';
    response: models.ContextNumericOutputV1;
  };
  'updateContextOpaque': {
    method: 'post';
    path: '/context/${encodeURIComponent(String(itemId))}/opaque/${encodeURIComponent(String(opaqueId))}';
    response: models.ContextOpaqueOutputV1;
  };
  'updateLabel': {
    method: 'post';
    path: '/context/labels/${encodeURIComponent(String(labelId))}';
    response: models.LabelOutputV1;
  };
  'updateLabelCategory': {
    method: 'post';
    path: '/context/labels/categories/${encodeURIComponent(String(categoryId))}';
    response: models.LabelCategoryOutputV1;
  };
  'updateNumericDescription': {
    method: 'post';
    path: '/context/numeric/${encodeURIComponent(String(id))}';
    response: models.ContextNumericOutputV1;
  };
  'updateReasonCodeHierarchy': {
    method: 'put';
    path: '/context/reason-codes/${encodeURIComponent(String(categoryId))}';
    response: models.ReasonCodeHierarchyOutputV1;
  };
};

type ApiAssignReasonCodeHierarchyResponse = {};
type ApiassignReasonCodeHierarchyMutationParams = Parameters<typeof sqContextApi.assignReasonCodeHierarchy> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.assignReasonCodeHierarchy>;

export function useApiAssignReasonCodeHierarchyMutation(
  options?: Omit<UseMutationOptions<ApiAssignReasonCodeHierarchyResponse, AxiosError<SeeqErrorData>,
    ApiassignReasonCodeHierarchyMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiAssignReasonCodeHierarchyResponse, AxiosError<SeeqErrorData>,
  ApiassignReasonCodeHierarchyMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiassignReasonCodeHierarchyMutationParams) =>
      sqContextApi.assignReasonCodeHierarchy(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiBatchArchiveContextLabelsResponse = {};
type ApibatchArchiveContextLabelsMutationParams = Parameters<typeof sqContextApi.batchArchiveContextLabels> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.batchArchiveContextLabels>;

export function useApiBatchArchiveContextLabelsMutation(
  options?: Omit<UseMutationOptions<ApiBatchArchiveContextLabelsResponse, AxiosError<SeeqErrorData>,
    ApibatchArchiveContextLabelsMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiBatchArchiveContextLabelsResponse, AxiosError<SeeqErrorData>,
  ApibatchArchiveContextLabelsMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApibatchArchiveContextLabelsMutationParams) =>
      sqContextApi.batchArchiveContextLabels(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiBatchCreateContextLabelsResponse = Array<models.ContextLabelOutputV1>;
type ApibatchCreateContextLabelsMutationParams = Parameters<typeof sqContextApi.batchCreateContextLabels> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.batchCreateContextLabels>;

export function useApiBatchCreateContextLabelsMutation(
  options?: Omit<UseMutationOptions<ApiBatchCreateContextLabelsResponse, AxiosError<SeeqErrorData>,
    ApibatchCreateContextLabelsMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiBatchCreateContextLabelsResponse, AxiosError<SeeqErrorData>,
  ApibatchCreateContextLabelsMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApibatchCreateContextLabelsMutationParams) =>
      sqContextApi.batchCreateContextLabels(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiBulkApplyContextResponse = models.BulkContextOutputV1;
type ApibulkApplyContextMutationParams = Parameters<typeof sqContextApi.bulkApplyContext> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.bulkApplyContext>;
type ApibulkApplyContextMutationVariables = models.BulkContextInputV1;

export function useApiBulkApplyContextMutation(
  options?: Omit<UseMutationOptions<ApiBulkApplyContextResponse, AxiosError<SeeqErrorData>,
    ApibulkApplyContextMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiBulkApplyContextResponse, AxiosError<SeeqErrorData>,
  ApibulkApplyContextMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApibulkApplyContextMutationVariables) =>
      sqContextApi.bulkApplyContext(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiBulkArchiveContextResponse = models.BulkContextArchiveOutputV1;
type ApibulkArchiveContextMutationParams = Parameters<typeof sqContextApi.bulkArchiveContext> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.bulkArchiveContext>;
type ApibulkArchiveContextMutationVariables = models.BulkContextArchiveInputV1;

export function useApiBulkArchiveContextMutation(
  options?: Omit<UseMutationOptions<ApiBulkArchiveContextResponse, AxiosError<SeeqErrorData>,
    ApibulkArchiveContextMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiBulkArchiveContextResponse, AxiosError<SeeqErrorData>,
  ApibulkArchiveContextMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApibulkArchiveContextMutationVariables) =>
      sqContextApi.bulkArchiveContext(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiCreateCommentCategoryResponse = models.CommentCategoryOutputV1;
type ApicreateCommentCategoryMutationParams = Parameters<typeof sqContextApi.createCommentCategory> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.createCommentCategory>;
type ApicreateCommentCategoryMutationVariables = models.CommentCategoryInputV1;

export function useApiCreateCommentCategoryMutation(
  options?: Omit<UseMutationOptions<ApiCreateCommentCategoryResponse, AxiosError<SeeqErrorData>,
    ApicreateCommentCategoryMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateCommentCategoryResponse, AxiosError<SeeqErrorData>,
  ApicreateCommentCategoryMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateCommentCategoryMutationVariables) =>
      sqContextApi.createCommentCategory(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiCreateContextCommentResponse = models.ContextCommentOutputV1;
type ApicreateContextCommentMutationParams = Parameters<typeof sqContextApi.createContextComment> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.createContextComment>;

export function useApiCreateContextCommentMutation(
  options?: Omit<UseMutationOptions<ApiCreateContextCommentResponse, AxiosError<SeeqErrorData>,
    ApicreateContextCommentMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateContextCommentResponse, AxiosError<SeeqErrorData>,
  ApicreateContextCommentMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApicreateContextCommentMutationParams) =>
      sqContextApi.createContextComment(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateContextLabelResponse = models.ContextLabelOutputV1;
type ApicreateContextLabelMutationParams = Parameters<typeof sqContextApi.createContextLabel> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.createContextLabel>;

export function useApiCreateContextLabelMutation(
  options?: Omit<UseMutationOptions<ApiCreateContextLabelResponse, AxiosError<SeeqErrorData>,
    ApicreateContextLabelMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateContextLabelResponse, AxiosError<SeeqErrorData>,
  ApicreateContextLabelMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApicreateContextLabelMutationParams) =>
      sqContextApi.createContextLabel(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateContextNumericResponse = models.ContextNumericOutputV1;
type ApicreateContextNumericMutationParams = Parameters<typeof sqContextApi.createContextNumeric> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.createContextNumeric>;

export function useApiCreateContextNumericMutation(
  options?: Omit<UseMutationOptions<ApiCreateContextNumericResponse, AxiosError<SeeqErrorData>,
    ApicreateContextNumericMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateContextNumericResponse, AxiosError<SeeqErrorData>,
  ApicreateContextNumericMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApicreateContextNumericMutationParams) =>
      sqContextApi.createContextNumeric(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateContextOpaqueResponse = models.ContextOpaqueOutputV1;
type ApicreateContextOpaqueMutationParams = Parameters<typeof sqContextApi.createContextOpaque> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.createContextOpaque>;

export function useApiCreateContextOpaqueMutation(
  options?: Omit<UseMutationOptions<ApiCreateContextOpaqueResponse, AxiosError<SeeqErrorData>,
    ApicreateContextOpaqueMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateContextOpaqueResponse, AxiosError<SeeqErrorData>,
  ApicreateContextOpaqueMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApicreateContextOpaqueMutationParams) =>
      sqContextApi.createContextOpaque(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateLabelResponse = models.LabelOutputV1;
type ApicreateLabelMutationParams = Parameters<typeof sqContextApi.createLabel> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.createLabel>;
type ApicreateLabelMutationVariables = models.LabelInputV1;

export function useApiCreateLabelMutation(
  options?: Omit<UseMutationOptions<ApiCreateLabelResponse, AxiosError<SeeqErrorData>,
    ApicreateLabelMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateLabelResponse, AxiosError<SeeqErrorData>,
  ApicreateLabelMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateLabelMutationVariables) =>
      sqContextApi.createLabel(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiCreateLabelCategoryResponse = models.LabelCategoryOutputV1;
type ApicreateLabelCategoryMutationParams = Parameters<typeof sqContextApi.createLabelCategory> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.createLabelCategory>;
type ApicreateLabelCategoryMutationVariables = models.LabelCategoryInputV1;

export function useApiCreateLabelCategoryMutation(
  options?: Omit<UseMutationOptions<ApiCreateLabelCategoryResponse, AxiosError<SeeqErrorData>,
    ApicreateLabelCategoryMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateLabelCategoryResponse, AxiosError<SeeqErrorData>,
  ApicreateLabelCategoryMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateLabelCategoryMutationVariables) =>
      sqContextApi.createLabelCategory(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiCreateNumericDescriptionResponse = models.NumericDescriptionOutputV1;
type ApicreateNumericDescriptionMutationParams = Parameters<typeof sqContextApi.createNumericDescription> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.createNumericDescription>;
type ApicreateNumericDescriptionMutationVariables = models.NumericDescriptionInputV1;

export function useApiCreateNumericDescriptionMutation(
  options?: Omit<UseMutationOptions<ApiCreateNumericDescriptionResponse, AxiosError<SeeqErrorData>,
    ApicreateNumericDescriptionMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateNumericDescriptionResponse, AxiosError<SeeqErrorData>,
  ApicreateNumericDescriptionMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateNumericDescriptionMutationVariables) =>
      sqContextApi.createNumericDescription(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiCreateReasonCodeHierarchyResponse = models.ReasonCodeHierarchyOutputV1;
type ApicreateReasonCodeHierarchyMutationParams = Parameters<typeof sqContextApi.createReasonCodeHierarchy> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.createReasonCodeHierarchy>;
type ApicreateReasonCodeHierarchyMutationVariables = models.ReasonCodeHierarchyInputV1;

export function useApiCreateReasonCodeHierarchyMutation(
  options?: Omit<UseMutationOptions<ApiCreateReasonCodeHierarchyResponse, AxiosError<SeeqErrorData>,
    ApicreateReasonCodeHierarchyMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateReasonCodeHierarchyResponse, AxiosError<SeeqErrorData>,
  ApicreateReasonCodeHierarchyMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateReasonCodeHierarchyMutationVariables) =>
      sqContextApi.createReasonCodeHierarchy(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiDeleteCommentCategoryResponse = {};
type ApideleteCommentCategoryMutationParams = Parameters<typeof sqContextApi.deleteCommentCategory> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.deleteCommentCategory>;

export function useApiDeleteCommentCategoryMutation(
  options?: Omit<UseMutationOptions<ApiDeleteCommentCategoryResponse, AxiosError<SeeqErrorData>,
    ApideleteCommentCategoryMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDeleteCommentCategoryResponse, AxiosError<SeeqErrorData>,
  ApideleteCommentCategoryMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApideleteCommentCategoryMutationParams) =>
      sqContextApi.deleteCommentCategory(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiDeleteContextCommentResponse = models.StatusMessageBase;
type ApideleteContextCommentMutationParams = Parameters<typeof sqContextApi.deleteContextComment> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.deleteContextComment>;

export function useApiDeleteContextCommentMutation(
  options?: Omit<UseMutationOptions<ApiDeleteContextCommentResponse, AxiosError<SeeqErrorData>,
    ApideleteContextCommentMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDeleteContextCommentResponse, AxiosError<SeeqErrorData>,
  ApideleteContextCommentMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApideleteContextCommentMutationParams) =>
      sqContextApi.deleteContextComment(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiDeleteContextLabelResponse = models.ArchiveOutputV1;
type ApideleteContextLabelMutationParams = Parameters<typeof sqContextApi.deleteContextLabel> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.deleteContextLabel>;

export function useApiDeleteContextLabelMutation(
  options?: Omit<UseMutationOptions<ApiDeleteContextLabelResponse, AxiosError<SeeqErrorData>,
    ApideleteContextLabelMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDeleteContextLabelResponse, AxiosError<SeeqErrorData>,
  ApideleteContextLabelMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApideleteContextLabelMutationParams) =>
      sqContextApi.deleteContextLabel(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiDeleteContextNumericResponse = models.StatusMessageBase;
type ApideleteContextNumericMutationParams = Parameters<typeof sqContextApi.deleteContextNumeric> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.deleteContextNumeric>;

export function useApiDeleteContextNumericMutation(
  options?: Omit<UseMutationOptions<ApiDeleteContextNumericResponse, AxiosError<SeeqErrorData>,
    ApideleteContextNumericMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDeleteContextNumericResponse, AxiosError<SeeqErrorData>,
  ApideleteContextNumericMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApideleteContextNumericMutationParams) =>
      sqContextApi.deleteContextNumeric(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiDeleteContextOpaqueResponse = models.StatusMessageBase;
type ApideleteContextOpaqueMutationParams = Parameters<typeof sqContextApi.deleteContextOpaque> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.deleteContextOpaque>;

export function useApiDeleteContextOpaqueMutation(
  options?: Omit<UseMutationOptions<ApiDeleteContextOpaqueResponse, AxiosError<SeeqErrorData>,
    ApideleteContextOpaqueMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDeleteContextOpaqueResponse, AxiosError<SeeqErrorData>,
  ApideleteContextOpaqueMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApideleteContextOpaqueMutationParams) =>
      sqContextApi.deleteContextOpaque(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiDeleteLabelResponse = models.ArchiveOutputV1;
type ApideleteLabelMutationParams = Parameters<typeof sqContextApi.deleteLabel> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.deleteLabel>;

export function useApiDeleteLabelMutation(
  options?: Omit<UseMutationOptions<ApiDeleteLabelResponse, AxiosError<SeeqErrorData>,
    ApideleteLabelMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDeleteLabelResponse, AxiosError<SeeqErrorData>,
  ApideleteLabelMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApideleteLabelMutationParams) =>
      sqContextApi.deleteLabel(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiDeleteLabelCategoryResponse = models.ArchiveOutputV1;
type ApideleteLabelCategoryMutationParams = Parameters<typeof sqContextApi.deleteLabelCategory> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.deleteLabelCategory>;

export function useApiDeleteLabelCategoryMutation(
  options?: Omit<UseMutationOptions<ApiDeleteLabelCategoryResponse, AxiosError<SeeqErrorData>,
    ApideleteLabelCategoryMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDeleteLabelCategoryResponse, AxiosError<SeeqErrorData>,
  ApideleteLabelCategoryMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApideleteLabelCategoryMutationParams) =>
      sqContextApi.deleteLabelCategory(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiDeleteNumericDescriptionResponse = {};
type ApideleteNumericDescriptionMutationParams = Parameters<typeof sqContextApi.deleteNumericDescription> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.deleteNumericDescription>;

export function useApiDeleteNumericDescriptionMutation(
  options?: Omit<UseMutationOptions<ApiDeleteNumericDescriptionResponse, AxiosError<SeeqErrorData>,
    ApideleteNumericDescriptionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDeleteNumericDescriptionResponse, AxiosError<SeeqErrorData>,
  ApideleteNumericDescriptionMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApideleteNumericDescriptionMutationParams) =>
      sqContextApi.deleteNumericDescription(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiDeleteReasonCodeHierarchyResponse = {};
type ApideleteReasonCodeHierarchyMutationParams = Parameters<typeof sqContextApi.deleteReasonCodeHierarchy> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.deleteReasonCodeHierarchy>;

export function useApiDeleteReasonCodeHierarchyMutation(
  options?: Omit<UseMutationOptions<ApiDeleteReasonCodeHierarchyResponse, AxiosError<SeeqErrorData>,
    ApideleteReasonCodeHierarchyMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDeleteReasonCodeHierarchyResponse, AxiosError<SeeqErrorData>,
  ApideleteReasonCodeHierarchyMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApideleteReasonCodeHierarchyMutationParams) =>
      sqContextApi.deleteReasonCodeHierarchy(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiFindLabelCategoriesResponse = models.LabelCategoryOutputListV1;
export function FindLabelCategoriesQueryKey(
  params: Parameters<typeof sqContextApi.findLabelCategories>[0],
) {
  return ['sqContextApi', 'findLabelCategories', params] as const;
}

export function useApiFindLabelCategoriesQuery(
  params: Parameters<typeof sqContextApi.findLabelCategories>[0],
  options?: Omit<UseQueryOptions<ApiFindLabelCategoriesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiFindLabelCategoriesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: FindLabelCategoriesQueryKey(params),
    queryFn: () =>
      sqContextApi.findLabelCategories(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiFindLabelsResponse = models.LabelOutputListV1;
export function FindLabelsQueryKey(
  params: Parameters<typeof sqContextApi.findLabels>[0],
) {
  return ['sqContextApi', 'findLabels', params] as const;
}

export function useApiFindLabelsQuery(
  params: Parameters<typeof sqContextApi.findLabels>[0],
  options?: Omit<UseQueryOptions<ApiFindLabelsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiFindLabelsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: FindLabelsQueryKey(params),
    queryFn: () =>
      sqContextApi.findLabels(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetAllCommentCategoriesResponse = models.CommentCategoryOutputListV1;
export function GetAllCommentCategoriesQueryKey(
) {
  return ['sqContextApi', 'getAllCommentCategories'] as const;
}

export function useApiGetAllCommentCategoriesQuery(
  options?: Omit<UseQueryOptions<ApiGetAllCommentCategoriesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetAllCommentCategoriesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetAllCommentCategoriesQueryKey(),
    queryFn: () =>
      sqContextApi.getAllCommentCategories(requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetAllContextResponse = models.AllContextOutputV1;
type ApigetAllContextMutationParams = Parameters<typeof sqContextApi.getAllContext> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.getAllContext>;
type ApigetAllContextMutationVariables = models.GetAllContextInputV1;

export function useApiGetAllContextMutation(
  options?: Omit<UseMutationOptions<ApiGetAllContextResponse, AxiosError<SeeqErrorData>,
    ApigetAllContextMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiGetAllContextResponse, AxiosError<SeeqErrorData>,
  ApigetAllContextMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApigetAllContextMutationVariables) =>
      sqContextApi.getAllContext(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiGetAllNumericDescriptionsResponse = models.NumericDescriptionOutputListV1;
export function GetAllNumericDescriptionsQueryKey(
) {
  return ['sqContextApi', 'getAllNumericDescriptions'] as const;
}

export function useApiGetAllNumericDescriptionsQuery(
  options?: Omit<UseQueryOptions<ApiGetAllNumericDescriptionsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetAllNumericDescriptionsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetAllNumericDescriptionsQueryKey(),
    queryFn: () =>
      sqContextApi.getAllNumericDescriptions(requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetAvailableConditionPropertiesResponse = models.AvailableConditionPropertiesOutputV1;
type ApigetAvailableConditionPropertiesMutationParams = Parameters<typeof sqContextApi.getAvailableConditionProperties> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.getAvailableConditionProperties>;
type ApigetAvailableConditionPropertiesMutationVariables = models.GetAvailableConditionPropertiesInputV1;

export function useApiGetAvailableConditionPropertiesMutation(
  options?: Omit<UseMutationOptions<ApiGetAvailableConditionPropertiesResponse, AxiosError<SeeqErrorData>,
    ApigetAvailableConditionPropertiesMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiGetAvailableConditionPropertiesResponse, AxiosError<SeeqErrorData>,
  ApigetAvailableConditionPropertiesMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApigetAvailableConditionPropertiesMutationVariables) =>
      sqContextApi.getAvailableConditionProperties(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiGetCommentCategoryResponse = models.CommentCategoryOutputV1;
export function GetCommentCategoryQueryKey(
  params: Parameters<typeof sqContextApi.getCommentCategory>[0],
) {
  return ['sqContextApi', 'getCommentCategory', params] as const;
}

export function useApiGetCommentCategoryQuery(
  params: Parameters<typeof sqContextApi.getCommentCategory>[0],
  options?: Omit<UseQueryOptions<ApiGetCommentCategoryResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetCommentCategoryResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetCommentCategoryQueryKey(params),
    queryFn: () =>
      sqContextApi.getCommentCategory(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetContextCommentsResponse = models.ContextCommentListOutputV1;
type ApigetContextCommentsMutationParams = Parameters<typeof sqContextApi.getContextComments> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.getContextComments>;
type ApigetContextCommentsMutationVariables = models.GetContextInputV1;

export function useApiGetContextCommentsMutation(
  options?: Omit<UseMutationOptions<ApiGetContextCommentsResponse, AxiosError<SeeqErrorData>,
    ApigetContextCommentsMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiGetContextCommentsResponse, AxiosError<SeeqErrorData>,
  ApigetContextCommentsMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApigetContextCommentsMutationVariables) =>
      sqContextApi.getContextComments(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiGetContextConditionsResponse = models.ContextConditionOutputListV1;
type ApigetContextConditionsMutationParams = Parameters<typeof sqContextApi.getContextConditions> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.getContextConditions>;
type ApigetContextConditionsMutationVariables = models.GetContextConditionInputV1;

export function useApiGetContextConditionsMutation(
  options?: Omit<UseMutationOptions<ApiGetContextConditionsResponse, AxiosError<SeeqErrorData>,
    ApigetContextConditionsMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiGetContextConditionsResponse, AxiosError<SeeqErrorData>,
  ApigetContextConditionsMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApigetContextConditionsMutationVariables) =>
      sqContextApi.getContextConditions(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiGetContextLabelsResponse = models.ContextLabelListOutputV1;
type ApigetContextLabelsMutationParams = Parameters<typeof sqContextApi.getContextLabels> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.getContextLabels>;
type ApigetContextLabelsMutationVariables = models.GetContextInputV1;

export function useApiGetContextLabelsMutation(
  options?: Omit<UseMutationOptions<ApiGetContextLabelsResponse, AxiosError<SeeqErrorData>,
    ApigetContextLabelsMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiGetContextLabelsResponse, AxiosError<SeeqErrorData>,
  ApigetContextLabelsMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApigetContextLabelsMutationVariables) =>
      sqContextApi.getContextLabels(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiGetContextNumericsResponse = models.ContextNumericListOutputV1;
type ApigetContextNumericsMutationParams = Parameters<typeof sqContextApi.getContextNumerics> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.getContextNumerics>;
type ApigetContextNumericsMutationVariables = models.GetContextInputV1;

export function useApiGetContextNumericsMutation(
  options?: Omit<UseMutationOptions<ApiGetContextNumericsResponse, AxiosError<SeeqErrorData>,
    ApigetContextNumericsMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiGetContextNumericsResponse, AxiosError<SeeqErrorData>,
  ApigetContextNumericsMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApigetContextNumericsMutationVariables) =>
      sqContextApi.getContextNumerics(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiGetContextOpaqueResponse = models.ContextOpaqueListOutputV1;
type ApigetContextOpaqueMutationParams = Parameters<typeof sqContextApi.getContextOpaque> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.getContextOpaque>;
type ApigetContextOpaqueMutationVariables = models.GetContextInputV1;

export function useApiGetContextOpaqueMutation(
  options?: Omit<UseMutationOptions<ApiGetContextOpaqueResponse, AxiosError<SeeqErrorData>,
    ApigetContextOpaqueMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiGetContextOpaqueResponse, AxiosError<SeeqErrorData>,
  ApigetContextOpaqueMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApigetContextOpaqueMutationVariables) =>
      sqContextApi.getContextOpaque(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiGetLabelHierarchiesResponse = models.LabelHierarchyOutputListV1;
type ApigetLabelHierarchiesMutationParams = Parameters<typeof sqContextApi.getLabelHierarchies> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.getLabelHierarchies>;
type ApigetLabelHierarchiesMutationVariables = models.LabelHierarchyInputV1;

export function useApiGetLabelHierarchiesMutation(
  options?: Omit<UseMutationOptions<ApiGetLabelHierarchiesResponse, AxiosError<SeeqErrorData>,
    ApigetLabelHierarchiesMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiGetLabelHierarchiesResponse, AxiosError<SeeqErrorData>,
  ApigetLabelHierarchiesMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApigetLabelHierarchiesMutationVariables) =>
      sqContextApi.getLabelHierarchies(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiGetLabeledItemsResponse = models.ItemPreviewListV1;
export function GetLabeledItemsQueryKey(
  params: Parameters<typeof sqContextApi.getLabeledItems>[0],
) {
  return ['sqContextApi', 'getLabeledItems', params] as const;
}

export function useApiGetLabeledItemsQuery(
  params: Parameters<typeof sqContextApi.getLabeledItems>[0],
  options?: Omit<UseQueryOptions<ApiGetLabeledItemsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetLabeledItemsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetLabeledItemsQueryKey(params),
    queryFn: () =>
      sqContextApi.getLabeledItems(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetNumericDescriptionResponse = models.NumericDescriptionOutputV1;
export function GetNumericDescriptionQueryKey(
  params: Parameters<typeof sqContextApi.getNumericDescription>[0],
) {
  return ['sqContextApi', 'getNumericDescription', params] as const;
}

export function useApiGetNumericDescriptionQuery(
  params: Parameters<typeof sqContextApi.getNumericDescription>[0],
  options?: Omit<UseQueryOptions<ApiGetNumericDescriptionResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetNumericDescriptionResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetNumericDescriptionQueryKey(params),
    queryFn: () =>
      sqContextApi.getNumericDescription(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetNumericDescriptionWithPathIdResponse = models.NumericDescriptionOutputV1;
export function GetNumericDescriptionWithPathIdQueryKey(
  params: Parameters<typeof sqContextApi.getNumericDescriptionWithPathId>[0],
) {
  return ['sqContextApi', 'getNumericDescriptionWithPathId', params] as const;
}

export function useApiGetNumericDescriptionWithPathIdQuery(
  params: Parameters<typeof sqContextApi.getNumericDescriptionWithPathId>[0],
  options?: Omit<UseQueryOptions<ApiGetNumericDescriptionWithPathIdResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetNumericDescriptionWithPathIdResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetNumericDescriptionWithPathIdQueryKey(params),
    queryFn: () =>
      sqContextApi.getNumericDescriptionWithPathId(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetReasonCodeHierarchyTreeResponse = models.ReasonCodeHierarchyTreeOutputV1;
export function GetReasonCodeHierarchyTreeQueryKey(
  params: Parameters<typeof sqContextApi.getReasonCodeHierarchyTree>[0],
) {
  return ['sqContextApi', 'getReasonCodeHierarchyTree', params] as const;
}

export function useApiGetReasonCodeHierarchyTreeQuery(
  params: Parameters<typeof sqContextApi.getReasonCodeHierarchyTree>[0],
  options?: Omit<UseQueryOptions<ApiGetReasonCodeHierarchyTreeResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetReasonCodeHierarchyTreeResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetReasonCodeHierarchyTreeQueryKey(params),
    queryFn: () =>
      sqContextApi.getReasonCodeHierarchyTree(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiListReasonCodeHierarchiesResponse = models.ReasonCodeListOutputV1;
export function ListReasonCodeHierarchiesQueryKey(
  params: Parameters<typeof sqContextApi.listReasonCodeHierarchies>[0],
) {
  return ['sqContextApi', 'listReasonCodeHierarchies', params] as const;
}

export function useApiListReasonCodeHierarchiesQuery(
  params: Parameters<typeof sqContextApi.listReasonCodeHierarchies>[0],
  options?: Omit<UseQueryOptions<ApiListReasonCodeHierarchiesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiListReasonCodeHierarchiesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: ListReasonCodeHierarchiesQueryKey(params),
    queryFn: () =>
      sqContextApi.listReasonCodeHierarchies(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiSearchContextCommentsResponse = models.ContextCommentSearchResultsV1;
export function SearchContextCommentsQueryKey(
  params: Parameters<typeof sqContextApi.searchContextComments>[0],
) {
  return ['sqContextApi', 'searchContextComments', params] as const;
}

export function useApiSearchContextCommentsQuery(
  params: Parameters<typeof sqContextApi.searchContextComments>[0],
  options?: Omit<UseQueryOptions<ApiSearchContextCommentsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiSearchContextCommentsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: SearchContextCommentsQueryKey(params),
    queryFn: () =>
      sqContextApi.searchContextComments(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiUpdateCommentCategoryResponse = models.CommentCategoryOutputV1;
type ApiupdateCommentCategoryMutationParams = Parameters<typeof sqContextApi.updateCommentCategory> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.updateCommentCategory>;

export function useApiUpdateCommentCategoryMutation(
  options?: Omit<UseMutationOptions<ApiUpdateCommentCategoryResponse, AxiosError<SeeqErrorData>,
    ApiupdateCommentCategoryMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUpdateCommentCategoryResponse, AxiosError<SeeqErrorData>,
  ApiupdateCommentCategoryMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiupdateCommentCategoryMutationParams) =>
      sqContextApi.updateCommentCategory(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateContextCommentResponse = models.ContextCommentOutputV1;
type ApiupdateContextCommentMutationParams = Parameters<typeof sqContextApi.updateContextComment> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.updateContextComment>;

export function useApiUpdateContextCommentMutation(
  options?: Omit<UseMutationOptions<ApiUpdateContextCommentResponse, AxiosError<SeeqErrorData>,
    ApiupdateContextCommentMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUpdateContextCommentResponse, AxiosError<SeeqErrorData>,
  ApiupdateContextCommentMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiupdateContextCommentMutationParams) =>
      sqContextApi.updateContextComment(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateContextNumericResponse = models.ContextNumericOutputV1;
type ApiupdateContextNumericMutationParams = Parameters<typeof sqContextApi.updateContextNumeric> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.updateContextNumeric>;

export function useApiUpdateContextNumericMutation(
  options?: Omit<UseMutationOptions<ApiUpdateContextNumericResponse, AxiosError<SeeqErrorData>,
    ApiupdateContextNumericMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUpdateContextNumericResponse, AxiosError<SeeqErrorData>,
  ApiupdateContextNumericMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiupdateContextNumericMutationParams) =>
      sqContextApi.updateContextNumeric(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateContextOpaqueResponse = models.ContextOpaqueOutputV1;
type ApiupdateContextOpaqueMutationParams = Parameters<typeof sqContextApi.updateContextOpaque> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.updateContextOpaque>;

export function useApiUpdateContextOpaqueMutation(
  options?: Omit<UseMutationOptions<ApiUpdateContextOpaqueResponse, AxiosError<SeeqErrorData>,
    ApiupdateContextOpaqueMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUpdateContextOpaqueResponse, AxiosError<SeeqErrorData>,
  ApiupdateContextOpaqueMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiupdateContextOpaqueMutationParams) =>
      sqContextApi.updateContextOpaque(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateLabelResponse = models.LabelOutputV1;
type ApiupdateLabelMutationParams = Parameters<typeof sqContextApi.updateLabel> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.updateLabel>;

export function useApiUpdateLabelMutation(
  options?: Omit<UseMutationOptions<ApiUpdateLabelResponse, AxiosError<SeeqErrorData>,
    ApiupdateLabelMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUpdateLabelResponse, AxiosError<SeeqErrorData>,
  ApiupdateLabelMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiupdateLabelMutationParams) =>
      sqContextApi.updateLabel(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateLabelCategoryResponse = models.LabelCategoryOutputV1;
type ApiupdateLabelCategoryMutationParams = Parameters<typeof sqContextApi.updateLabelCategory> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.updateLabelCategory>;

export function useApiUpdateLabelCategoryMutation(
  options?: Omit<UseMutationOptions<ApiUpdateLabelCategoryResponse, AxiosError<SeeqErrorData>,
    ApiupdateLabelCategoryMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUpdateLabelCategoryResponse, AxiosError<SeeqErrorData>,
  ApiupdateLabelCategoryMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiupdateLabelCategoryMutationParams) =>
      sqContextApi.updateLabelCategory(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateNumericDescriptionResponse = models.ContextNumericOutputV1;
type ApiupdateNumericDescriptionMutationParams = Parameters<typeof sqContextApi.updateNumericDescription> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.updateNumericDescription>;

export function useApiUpdateNumericDescriptionMutation(
  options?: Omit<UseMutationOptions<ApiUpdateNumericDescriptionResponse, AxiosError<SeeqErrorData>,
    ApiupdateNumericDescriptionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUpdateNumericDescriptionResponse, AxiosError<SeeqErrorData>,
  ApiupdateNumericDescriptionMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiupdateNumericDescriptionMutationParams) =>
      sqContextApi.updateNumericDescription(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateReasonCodeHierarchyResponse = models.ReasonCodeHierarchyOutputV1;
type ApiupdateReasonCodeHierarchyMutationParams = Parameters<typeof sqContextApi.updateReasonCodeHierarchy> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContextApi.updateReasonCodeHierarchy>;

export function useApiUpdateReasonCodeHierarchyMutation(
  options?: Omit<UseMutationOptions<ApiUpdateReasonCodeHierarchyResponse, AxiosError<SeeqErrorData>,
    ApiupdateReasonCodeHierarchyMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUpdateReasonCodeHierarchyResponse, AxiosError<SeeqErrorData>,
  ApiupdateReasonCodeHierarchyMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiupdateReasonCodeHierarchyMutationParams) =>
      sqContextApi.updateReasonCodeHierarchy(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
